import {SAMPLER, AUDIO, MIDI, INSTRUMENT, INSTRUMENT_RACK} from 'constants/track-types.js';
import {
    SAMPLED_INSTRUMENT,
    SYNTH,
    MULTI_SYNTH,
    FM_SYNTH,
    METAL_SYNTH,
    EXTERNAL_INSTRUMENT,
} from 'constants/instrument-types.js';
import FMSynthTrack from 'track/FMSynthTrack.js';
import MultiSynthTrack from 'track/MultiSynthTrack.js';
import InstrumentTrack from 'track/InstrumentTrack.js';
import InstrumentRackTrack from 'track/InstrumentRackTrack.js';
import SampledInstrumentTrack from 'track/SampledInstrumentTrack.js';

export function constructTrack(
    sequencerEngine,
    trackType,
    instrumentType,
    numberOfPatterns=sequencerEngine.numberOfPatterns()) {
    let track = undefined;
    if (trackType === INSTRUMENT) {
        switch (instrumentType) {
        case FM_SYNTH:
            track = new FMSynthTrack(
                sequencerEngine.tracks.length,
                sequencerEngine,
                sequencerEngine.mixSession,
                numberOfPatterns,
                () => sequencerEngine.update(),
                sequencerEngine.currentSubSequence);
            break;
        case MULTI_SYNTH:
            track = new MultiSynthTrack(
                sequencerEngine.tracks.length,
                sequencerEngine,
                sequencerEngine.mixSession,
                numberOfPatterns,
                () => sequencerEngine.update(),
                sequencerEngine.currentSubSequence);
            break;
        case SYNTH:
            track = new InstrumentTrack(
                sequencerEngine.tracks.length,
                sequencerEngine,
                sequencerEngine.mixSession,
                numberOfPatterns,
                () => sequencerEngine.update(),
                sequencerEngine.currentSubSequence);
            break;
        case SAMPLED_INSTRUMENT:
            track = new SampledInstrumentTrack(
                sequencerEngine.tracks.length,
                sequencerEngine,
                sequencerEngine.mixSession,
                numberOfPatterns,
                () => sequencerEngine.update(),
                sequencerEngine.currentSubSequence);
            break;
        }
    } else if (trackType === INSTRUMENT_RACK) {
        track = new InstrumentRackTrack(
            sequencerEngine.tracks.length,
            sequencerEngine,
            sequencerEngine.mixSession,
            numberOfPatterns,
            () => sequencerEngine.update(),
            sequencerEngine.currentSubSequence);
    }
    if (track === undefined) {
        return undefined;
    }

    /*
    track.sequencerEngine = sequencerEngine;
    track.setKeyboardEngine(sequencerEngine.keyboardEngine);
    */

    return track;
}
